// apps/nos/client/src/utils/formatRelative.ts
//
// ISO-string in → short relative display string out.
// Buckets:
//   < 60s          → "just now"
//   < 60m          → "Nm ago"
//   same calendar day  → "Nh ago"
//   yesterday      → "Yesterday"
//   this calendar year → "Mon DD"
//   earlier        → "Mon DD, YYYY"

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function formatRelative(iso: string, now: Date = new Date()): string {
  const t = new Date(iso);
  if (Number.isNaN(t.getTime())) return "";

  const diffMs = now.getTime() - t.getTime();
  const diffSec = Math.floor(diffMs / 1000);

  if (diffSec < 60) return "just now";

  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;

  const sameDay =
    t.getFullYear() === now.getFullYear() &&
    t.getMonth() === now.getMonth() &&
    t.getDate() === now.getDate();
  if (sameDay) {
    const diffHr = Math.floor(diffMin / 60);
    return `${diffHr}h ago`;
  }

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday =
    t.getFullYear() === yesterday.getFullYear() &&
    t.getMonth() === yesterday.getMonth() &&
    t.getDate() === yesterday.getDate();
  if (isYesterday) return "Yesterday";

  const month = MONTHS[t.getMonth()] ?? "";
  const monDD = `${month} ${String(t.getDate()).padStart(2, "0")}`;
  if (t.getFullYear() === now.getFullYear()) return monDD;
  return `${monDD}, ${t.getFullYear()}`;
}
